import React, { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import CategoriesTab from "../../../containers/categories-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Category } from "../../../models/Category";
import { getCategories } from "../../../services/categoriesService";
import { showError } from "../../../services/utilities/ServiceError";

const Categories: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            const categories = await getCategories();
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.categories),
                    heading: translate.byKey(TranslationKeys.categories),
                    value: "",
                    id: 0,
                    count: categories.pagination.totalCount,
                },
            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<CategoriesTab setBusy={setBusy}></CategoriesTab>];
            setTabContent(newTabContent);
        }
    }, [categories]);

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/enrolment",
                                displayName: translate.byKey(TranslationKeys.enrolments),
                            },
                            {
                                value: "/access-control/enrolment/categories",
                                displayName: translate.byKey(TranslationKeys.categories),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        setSelectedTab={setSelected}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default Categories;
